import { render, staticRenderFns } from "./ProductLevelTable.vue?vue&type=template&id=020661ab&scoped=true&"
import script from "./ProductLevelTable.vue?vue&type=script&lang=js&"
export * from "./ProductLevelTable.vue?vue&type=script&lang=js&"
import style0 from "./ProductLevelTable.vue?vue&type=style&index=0&id=020661ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020661ab",
  null
  
)

export default component.exports